import React from 'react'
import loaderGif from '../../../assets/hilbi-loader.gif'

const Loader: React.FC = () => <img src={loaderGif} alt='app loader' />

export default Loader
